import { TranslateService } from "@ngx-translate/core";
import { Pipe, PipeTransform } from "@angular/core";
import { PartDriveBTranslations } from "@shared/models/part-dto";
import {
  LanguageEnum,
  angularToKeycloakCode
} from "@shared/enums/language.enum";

@Pipe({
    name: "translationName",
    standalone: false
})
export class TranslationNamePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: PartDriveBTranslations[], ...args: any[]): string {
    const translationName = value.find(
      (translation) =>
        translation.locale.code ===
        angularToKeycloakCode(this.translateService.currentLang as LanguageEnum)
    );

    return translationName ? translationName.value : null;
  }
}
